var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"15","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M11.78 0l2.595 2.593-8.56 8.41 8.56 8.404L11.781 22 .625 11.004 11.781 0z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }